<template>
  <div
      :id="uniqueId()"
      class="checkbox-button-label"
      :class="checkboxClasses"
      @click="onChange"
  >
    <div class="container">
      <div class="tick">
        <svg
            v-if="chosen"
            width="9"
            height="12"
            viewBox="0 0 9 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
          <path
              d="M3.78969 7.07691C3.73657 7.07522 3.68438 7.06332 3.6363 7.04194C3.58823 7.02056 3.5453 6.99014 3.51013 6.95255L0.872771 4.46528C0.822486 4.43453 0.780265 4.39341 0.749296 4.34503C0.718328 4.29664 0.699421 4.24225 0.694003 4.18596C0.688585 4.12967 0.696798 4.07296 0.718021 4.02011C0.739244 3.96725 0.772923 3.91963 0.816515 3.88085C0.860108 3.84206 0.912473 3.81313 0.969659 3.79622C1.02684 3.77932 1.08736 3.77488 1.14662 3.78326C1.20589 3.79164 1.26236 3.81261 1.31178 3.84458C1.3612 3.87655 1.40227 3.91869 1.43189 3.96783L3.78969 6.17652L9.31233 0.983106C9.38668 0.937643 9.47506 0.917038 9.56331 0.924593C9.65156 0.932149 9.73456 0.967426 9.79902 1.02477C9.86347 1.08212 9.90565 1.15821 9.91878 1.24086C9.93192 1.3235 9.91525 1.40791 9.87145 1.48056L4.06925 6.95255C4.03409 6.99014 3.99115 7.02056 3.94308 7.04194C3.89501 7.06332 3.84281 7.07522 3.78969 7.07691Z"
              fill="white"
          />
        </svg>
      </div>
    </div>
    <div
        v-if="htmlTitle"
        class="text"
        v-html="title"
    />
    <div
        v-if="!htmlTitle && title"
        class="text"
        :style="{'width': titleWidth + 'px'}"
    >
      {{ title }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'CheckBox',
  props: {
    chosen: Boolean,
    partiallyFill: Boolean,
    titleWidth: {
      type: Number,
      required: false,
    },

    id: {
      type: String,
      required: false,
      default: '',
    },

    title: {
      type: String,
      required: false,
      default: '',
    },

    htmlTitle: {
      type: Boolean,
      required: false,
    },

    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },

    mode: {
      type: Array,
      required: false,
      default: () => [],
    },
  },

  computed: {
    checkboxClasses() {
      return {
        'checkbox-button-label_checked': this.chosen,
        'checkbox-button-label_partial': this.partiallyFill,
        'checkbox-button-label_dark': this.modeExists('dark'),
        'checkbox-button-label_exportbase': this.modeExists('exportbase'),
        'checkbox-button-label_aligntop': this.modeExists('aligntop'),
        'checkbox-button_disabled': this.modeExists('disabled'),
        'checkbox-button-label_main_filters_option': this.modeExists('main_filters_option'),
      };
    },
  },

  methods: {
    onChange() {
      if (!this.disabled) {
        this.$emit('change', this.id);
      }
    },

    modeExists(mode) {
      return (this.mode.indexOf(mode) !== -1);
    },

    uniqueId() {
        const propsString = JSON.stringify({
          title: this.title,
          mode: this.mode,
          htmlTitle: this.htmlTitle ?? false,
          chosen: this.chosen
        });

        let hash = 0;
        for (let i = 0; i < propsString.length; i++) {
          hash = ((hash << 5) - hash) + propsString.charCodeAt(i);
          hash = hash & hash;
        }

        return `${this.id}_${Math.abs(hash).toString(36)}`;
      }
    },
};
</script>

<style scoped>
.checkbox-button-label {
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  line-height: 17px;
  cursor: pointer;
}

.checkbox-button-label_aligntop {
  align-items: flex-start;
}

.container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 16px;
  height: 16px;
  background: #E1E1E1;
  border-radius: 6px;
  border: 1px solid #DDD;
  position: relative;
}

.tick {
  position: relative;
  width: 16px;
  height: 16px;
  border-radius: 5px;
  transition: background-color 0.15s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
}

.tick svg {
  width: 9px;
  height: 12px;
  position: absolute;
  top: 4px;
  left: 3px;
}

.tick::after {
  content: "";
  position: absolute;
  width: 14px;
  height: 5px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 6px;
  background-color: transparent;
  transition: background-color 0.15s ease-in-out;
}

.text {
  display: inline-block;
  margin-left: 10px;
  word-break: break-word;
}

.checkbox-button-label_checked .tick {
  background: #91AD2C;
}

.checkbox-button-label_checked .tick svg {
  fill: white;
}

.checkbox-button-label_partial .tick {
  background: #E1E1E1;
  position: relative;
}

.checkbox-button-label_partial .tick::after {
  content: "";
  width: 10px;
  height: 5px;
  background: #769210;
  border-radius: 1px;
  position: absolute;
  overflow: hidden;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.checkbox-button-label_dark .container {
  background: #B8B8B8;
}

.checkbox-button-label_exportbase .text {
  margin-left: 5px;
  padding: 3px 5px;
  background: transparent;
}

.checkbox-button-label_exportbase.checkbox-button-label_checked .text {
  background: linear-gradient(270deg, #91ad2c, #839f22);
  padding: 3px 5px;
  border-radius: 2px;
  color: #fff;
}

.checkbox-button-label_exportbase.checkbox-button-label_main_filters_option .text {
  margin-left: 6px;
}

.checkbox-button_disabled {
  opacity: 0.5;
  cursor: default;
}

.checkbox-button_disabled .tick {
  background: #91AD2C;
}
</style>
